import React from 'react'
import { Heading1 } from '@/components/ui/typography'
import styled from 'styled-components'

import { WorldCheckLogo } from './WorldCheckLogo'

interface Props {
  onWorldCheckNoRecordsFoundResolve?(): void
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
  button {
    text-transform: uppercase;
    cursor: pointer;
    height: 32px;
    width: 80px;
    background: #fff;
    text-align: center;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
      color: rgba(0, 0, 0, 0.65);
      color: #40a9ff;
      background-color: #fff;
      border-color: #40a9ff;
      outline: 0;
    }
  }
`

export const ClientDetailsNoMatch: React.FC<Props> = ({ onWorldCheckNoRecordsFoundResolve }) => (
  <Container>
    <WorldCheckLogo />
    <Heading1>No matching records found</Heading1>
    <button onClick={onWorldCheckNoRecordsFoundResolve}>Ok</button>
  </Container>
)
